export default __webpack_public_path__ + "static/media/banner.e656f630.png";